import { dataTransferWrap } from '../dataTransferService'
import { ModulesMap } from '@/config/data/modulesMaps'
import dtConfig from '@/config/data-transfer'

function getCurrentUser() {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].getCurrentUser)
}

function getAvailableCompanies() {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].getAvailableCompanies)
}

function getPermissions() {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].getPermissions)
}

function putUser(userId, data) {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].putUser, {
		urlParams: {
			userId,
		},
		...data,
	})
}

function patchUser(userId, data) {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].patchUser, {
		urlParams: {
			userId,
		},
		...data,
	})
}

function setPassword(data) {
	return dataTransferWrap(ModulesMap.USER,dtConfig[ModulesMap.USER].setPassword, {
		...data,
	})
}

export default {
	getCurrentUser,
	getAvailableCompanies,
	getPermissions,
	putUser,
	patchUser,
	setPassword,
}
